export default {
  EXAM_DEFERRAL: "exams/deferrals",
  PATCH_EXAM_DEFERRAl: "exams/deferrals/update",
  SHOW_EXAM_DEFERRAL: (id) => `exams/deferrals/show?no=${id}`,
  DELETE_EXAM_DEFERRAL: "exams/deferrals/delete",
};
